import React from 'react';
import Auth from './Auth';
import Popup from "reactjs-popup";
import firebase from 'firebase'


class AuthButton extends React.Component {
    render(){
        return (
            <div style={{paddingLeft:"41%", paddingRight:"3%"}}>
                {/* If the user is not logged in, auth button is a buttn that triggers a signin popup */}
                {!this.props.loggedIn && 
                <Popup trigger={<button>Sign In</button>} modal position="left center">
                    <Auth loggedIn={this.props.loggedIn}></Auth>
                </Popup>}
                {/* If the user is logged in, this button can be rendered as some other button e.g. new post */}
                {this.props.loggedIn &&
                <button style={{borderRadius: 100, padding: "15 40"}} onClick ={ () => firebase.auth().signOut()} >Sign Out</button>}
            </div>
            )
    }
}

export default AuthButton;

